var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack429({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.73,10.22l1.55-.15a1.87,1.87,0,0,0,.56,1.14A1.7,1.7,0,0,0,8,11.58a1.73,1.73,0,0,0,1.15-.33,1,1,0,0,0,.39-.76A.71.71,0,0,0,9.38,10a1.26,1.26,0,0,0-.57-.34c-.19-.07-.61-.18-1.28-.35a4.39,4.39,0,0,1-1.79-.77A2.09,2.09,0,0,1,5,7a2,2,0,0,1,.35-1.12,2.06,2.06,0,0,1,1-.8,4,4,0,0,1,1.55-.28,3.33,3.33,0,0,1,2.23.65,2.34,2.34,0,0,1,.79,1.74l-1.59.07a1.34,1.34,0,0,0-.44-.87,1.6,1.6,0,0,0-1-.27,1.8,1.8,0,0,0-1.08.29.56.56,0,0,0-.26.48.6.6,0,0,0,.24.48,4.09,4.09,0,0,0,1.46.53A7.41,7.41,0,0,1,10,8.44a2.22,2.22,0,0,1,.87.79,2.53,2.53,0,0,1-.06,2.53,2.39,2.39,0,0,1-1.07.88A4.5,4.5,0,0,1,8,12.92a3.39,3.39,0,0,1-2.29-.69A3,3,0,0,1,4.73,10.22Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack429);
export default __webpack_public_path__ + "static/media/Symbolpack_4_29.9d1b7e23d22a258f3e5276e8e85c52b0.svg";
export { ForwardRef as ReactComponent };